import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import {
  intentFlowValidation,
  intentJsonValidation
} from '@/services/intent/validation.service'

export const intentValidationMixin = {
  mixins: [validationMixin],

  computed: {
    intentErrors () {
      const jsonIntent = this.jsonIntentErrors
      const flowIntent = this.flowIntentErrors
      const textIntent = this.textIntentErrors

      const isValid = Object.keys(jsonIntent).length === 0 &&
                Object.keys(flowIntent).length === 0 &&
                Object.keys(textIntent).length === 0

      return {
        jsonIntent,
        flowIntent,
        textIntent,
        isValid
      }
    },

    jsonIntentErrors () {
      const errors = {}
      const { name } = this.$v.localIntent
      if (name.$dirty && !name.intentJsonValidation) {
        errors.json = this.$t('validations.intent-validation.json.invalid')
      }
      return errors
    },

    flowIntentErrors () {
      const errors = {}
      const { name } = this.$v.localIntent
      if (name.$dirty && !name.intentFlowValidation) {
        errors.name = this.$t('validations.intent-validation.flow.required')
      }
      return errors
    },

    textIntentErrors () {
      const errors = {}
      const { name } = this.$v.localIntent
      if (name.$dirty) {
        if (!name.intentTextRequired) {
          errors.name = this.$t('validations.intent-validation.text.required')
        }
      }
      return errors
    }
  },

  validations: {
    localIntent: {
      name: {
        intentFlowValidation,
        intentJsonValidation,
        intentTextRequired: required
      },
      type: {}
    }
  },

  watch: {
    'localIntent.name': function () {
      this.$v.localIntent.name.$touch()
    },
    'localIntent.type': function () {
      this.$v.localIntent.name.$reset()
    }
  }
}
